import { kuiperClassNames, renderIcon } from '@opallabs/kuiper'
import { Image as LapidaryImage } from '@opallabs/lapidary'
import { CoverImageDisplayMode } from '../../../../types'
import { useWeekViewSettings } from '../../../../WeekViewSettingsContext'
import type { Moment } from '../../momentCardTypes'

type MomentCardImageProps = {
  moment: Moment
}

export const MomentCardImage: React.FC<MomentCardImageProps> = ({ moment }) => {
  const { coverImageDisplay } = useWeekViewSettings()
  const previewImage = moment.preview || null
  const isScaled = coverImageDisplay === CoverImageDisplayMode.Scaled
  const imageStyle = isScaled ? { width: '100%', height: 'auto' } : {}

  return (
    <div className={kuiperClassNames('momentCard-mediaPreview')}>
      {moment.uploadPreview && (
        <div
          className={kuiperClassNames('momentCard-coverImage', {
            active: !previewImage,
          })}
        >
          <LapidaryImage
            alt={moment.uploadPreview.alt}
            imageFit="cover"
            src={moment.uploadPreview.url}
            title={moment.uploadPreview.title}
          />
        </div>
      )}
      {!moment.uploadPreview && previewImage !== null && (
        <div
          className={kuiperClassNames('momentCard-coverImage', {
            active: !previewImage,
            'custom-coverImage': isScaled,
          })}
          style={imageStyle}
        >
          <LapidaryImage
            alt={previewImage.alt}
            imageFit={isScaled ? 'scale-down' : 'cover'}
            src={previewImage.url}
            title={previewImage.title}
          />
        </div>
      )}
      <div className={kuiperClassNames('momentCard-selectedOverlay')}>
        <div
          className={kuiperClassNames('momentCard-selectedOverlay-iconWrapper')}
        >
          {renderIcon('sign-out', {
            style: { color: '#ffffff', height: 14, width: 14 },
            ariaLabel: 'Share this moment',
            ariaMode: 'presentational',
          })}
        </div>
      </div>
    </div>
  )
}
